import UpdatePasswordForm from "../../features/resetPassword/UpdatePasswordForm";
import React from "react"
import "./UpdatePass.scss";

const UpdatePassword = () => {
    return (
        <div>
            <UpdatePasswordForm />
        </div>
    )
};

export default UpdatePassword;
